import React from 'react';
import { Col } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import styles from './stepperStyles.less';

const StepperImage = (props) => {
  const { backgroundImageColor, image, isMobileView } = props;

  return (
    <Col key='imageComponent' sm={6} xs={12} className={styles.imageColumn}>
      <div
        className={styles.stepperImage}
        style={{
          height: '100%',
          borderRadius: '24px',
          backgroundColor: backgroundImageColor,
          padding: isMobileView ? '12px' : '40px',
        }}
      >
        <div
          style={{
            height: '100%',
            backgroundImage: `url(${image}) `,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
          }}
        ></div>
      </div>
    </Col>
  );
};

StepperImage.propTypes = {
  image: PropTypes.string.isRequired,
  backgroundImageColor: PropTypes.string.isRequired,
  isMobileView: PropTypes.bool,
};

StepperImage.defaultProps = {
  isMobileView: false,
};

export { StepperImage };
